import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Nav from "./Nav";

class SiteNav extends Component {
  render() {
    return (
      <nav className="sidebar shadow text-center">
        <Nav key={"sidebar-nav"} {...this.props}></Nav>
      </nav>
    );
  }
}

export default withRouter(SiteNav);
